export default __webpack_public_path__ + "static/media/gold-icon.74c54bb5.png";